export { default } from './HoldsBatchActionOptions';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsBatchActionOptions/index.js